module.exports = __webpack_public_path__ + "school/img/rencaiku.a7303f9e.jpg";